import api from "../config/api";
export const postSimulationCardPayment = async (data) => {
  let simulationReturn = {};
  try {
    let simulationResponse = await api.post(
      "Debitos/GerarSimulacaoCartaoCredito",
      data
    );
    simulationReturn = simulationResponse.data;
  } catch (error) {
    simulationReturn =
      "Erro ao carregar simulação de cartão de crédito ativos.";
  }
  return simulationReturn;
};
